module.exports = __webpack_public_path__ + "static/media/magazzino.7e34ed59.jpg";